// ------------------------------------------------------------------------------
// name: pathname
// author: mudas
// created: 2024/12/20
// ------------------------------------------------------------------------------

export enum MANAGER_ROUTER {
  WORKFLOW = 'workflow',
  ARTIST_HOME = 'artist-home',
  TIAN_GONG = 'tiangong',

  CERTIFICATE_MANAGEMENT = 'cetificate-management',
  HANDLING_BIDDING_TASK = 'handling-bidding-task',
  ARTIST_MANAGEMENT = 'artist-management',
  FUNDS_MANAGEMENT = 'funds-management',

  // 用户管理
  USER_MANAGEMENT = 'user-management',

  // 企业任务管理
  EnterpriseRequirement = 'enterprise-requirement',
  EnterpriseBiddingDetail = 'enterprise-bidding-detail',

  // 个人任务管理
  PersonalRequirement = 'personal-requirement',
  PersonalBiddingDetail = 'personal-bidding-detail',

  // 数据报表
  DATA_REPORT = 'data-report',

  // 合同管理
  CONTRACT_MANAGEMENT = 'contract-management',

  // 云桌面管理
  CLOUD_DESKTOP = 'cloud-desktop',

  // 运营推荐工具
  RECOMMENDED_TOOLS = 'recommended-tools',

  // 运营推荐创作者详情
  RECOMMENDED_ARTIST_DETAIL = 'recommended-artist-detail',

  // 权限配置
  PERMISSION = 'permission',

  // 项目空间配置
  NAME_SPACE = 'namespace',

  // 工坊管理
  WORKSHOP = 'workshop',

  // 工坊订单管理
  WORKSHOP_ORDER = 'workshop-order',

  // 活动配置
  ACTIVITY_CONFIGURE = 'activity-configure',

  // 用户反馈
  FEEDBACK_MANAGEMENT = 'feedback-management',
}
